import React, { useEffect, useState } from "react";
import { EmptyState } from "./common";

function itemType(item) {
  if (item.type) return item.type;
  const url = String(item.url || "").toLowerCase();
  if (url.endsWith(".pdf")) return "pdf";
  if (/\.(png|jpe?g|gif|webp|svg)$/.test(url)) return "image";
  return "web";
}

// Rotates through configured media (images / PDFs / embedded pages), each shown
// for its own duration. Third-party embeds are isolated by the widget frame's
// error boundary.
const MediaRotationWidget = ({ config = {} }) => {
  const items = config.items || [];
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (items.length <= 1) return undefined;
    const current = items[index] || items[0];
    const ms = Math.max(4000, (current.duration || 10) * 1000);
    const t = setTimeout(() => setIndex((i) => (i + 1) % items.length), ms);
    return () => clearTimeout(t);
  }, [index, items]);

  useEffect(() => {
    if (index >= items.length && items.length > 0) setIndex(0);
  }, [items.length, index]);

  if (items.length === 0) {
    return (
      <div className="sb-card sb-media">
        <EmptyState icon="🖼" label="Add media in the Board Designer." />
      </div>
    );
  }

  const item = items[Math.min(index, items.length - 1)];
  const type = itemType(item);

  return (
    <div className="sb-card sb-media">
      {type === "image" ? (
        <img className="sb-media-img" src={item.url} alt={item.name || ""} />
      ) : (
        <iframe
          className="sb-media-frame"
          title={item.name || `media-${index}`}
          src={type === "pdf" ? `${item.url}#toolbar=0&navpanes=0` : item.url}
          frameBorder="0"
          allowFullScreen
        />
      )}
    </div>
  );
};

export default MediaRotationWidget;
